import React, { useState, useRef, useEffect } from "react";

const TalkToFozzilButton = () => {
  const [query, setQuery] = useState("");
  const [expanded, setExpanded] = useState(false);
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (expanded && inputRef.current) {
      inputRef.current.focus();
    }
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setExpanded(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === "Escape") setExpanded(false);
    };
    if (expanded) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEsc);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [expanded]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && query.trim()) {
      window.open(`https://intelligence.fozzil.in/?q=${encodeURIComponent(query)}`, "_blank", "noopener,noreferrer");
    }
  };

  const handleArrowClick = (e) => {
    e.stopPropagation();
    if (query.trim()) {
      window.open(`https://intelligence.fozzil.in/?q=${encodeURIComponent(query)}`, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <div
        className={`fixed left-1/2 bottom-10 transform -translate-x-1/2 bg-neutral-800 rounded-full flex items-center justify-between shadow-lg font-secondary z-[2000] transition-all duration-400 cursor-pointer min-w-[200px] max-w-[220px] w-auto opacity-100 px-1 py-[0.68rem] text-base md:text-base ${
          expanded
            ? "min-w-[260px] max-w-[340px] w-full px-4 cursor-default"
            : ""
        } ${expanded ? "" : "hover:bg-neutral-600"}`}
        ref={wrapperRef}
        onClick={() => !expanded && setExpanded(true)}
        style={{ fontFamily: "var(--font-secondary, sans-serif)" }}
      >
        {expanded ? (
          <>
            <input
              ref={inputRef}
              className="flex-1 bg-neutral-800 text-white border-none outline-none rounded-full text-base md:text-base px-4 py-2 min-w-0 max-w-full font-secondary placeholder:text-gray-300 focus:ring-0"
              type="text"
              placeholder="Command FOZZIL..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
              onClick={(e) => e.stopPropagation()}
              style={{ fontFamily: "var(--font-secondary, sans-serif)" }}
            />
            <span
              className=" flex items-center justify-center rounded-full cursor-pointer transition-colors duration-200 hover:bg-neutral-600"
              onClick={handleArrowClick}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="12" fill="#aaa" />
                <path
                  d="M8 15l4-4-4-4"
                  stroke="#222"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </>
        ) : (
          <>
            <span className="text-white text-base font-medium ml-2 tracking-wide whitespace-nowrap overflow-hidden text-ellipsis mr-3">
              Command FOZZIL
            </span>
            <span className="flex items-center justify-center ml-2 mr-2">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="12" fill="#aaa" />
                <path
                  d="M8 15l4-4-4-4"
                  stroke="#222"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </>
        )}
      </div>
    </>
  );
};

export default TalkToFozzilButton;
